import './modules/lodash';
import { getViewData, setViewData } from './modules/view-data';
import Vue from 'vue';

/**
 * Load window globals
 */
import 'bootstrap';
import 'sweetalert';

Vue.config.debug = Vue.config.devtools = getViewData('debug') || window.location.search.includes('__debug');
if (process.env.NODE_ENV !== 'production') {
    window.VUE_DEVTOOLS_CONFIG = {
        openInEditorHost: __webpack_public_path__,
    };
}

/**
 * Configure Vue ajax requests
 */
Vue.http.options.root = getViewData('CLIENT_API_URL');
setViewData('CLIENT_API_URL_BASE', getViewData('CLIENT_API_URL', '').replace('/api/v2', ''));
Vue.http.headers.common['Accept'] = 'application/json';
Vue.http.headers.common['Content-Type'] = 'application/json';

Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', getViewData('csrf_token'));
    request.headers.set('X-Requested-With', 'XMLHttpRequest');

    request.credentials = true;

    // continue to next interceptor
    next();
});

// Update the CSRF token if sent back in the
// response of any request
Vue.http.interceptors.push(() => ({ data }) => {
    if (data.csrf_token) {
        setViewData('csrf_token', data.csrf_token);
    }
});
